import { Typography, useMediaQuery } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { RoundedArrowButton } from 'src/components/buttons';
import RoundInfo from 'src/components/common/RoundInfo';
import { imageUrl } from 'src/utils'

const NotFeelingWell = () => {
  const navigate = useNavigate();
  const bgSize = '200px'
  const bgRepeat = 'no-repeat'
  const bgPosition = 'right -20px bottom -10px'
  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');
  const isLessThan640 = useMediaQuery('(max-width: 640px)');
  return (
    <div className='bg-[#FCAE4C] w-[92%] md:w-[88%] lg:w-[84%] max-w-[1100px] mx-auto rounded-2xl py-6 md:py-6 lg:py-7 px-5 md:px-7 lg:px-10 flex flex-col md:flex-row items-center justify-between overflow-hidden mb-12 md:mb-16 lg:mb-20 relative z-0'>
      {/* Background illustration */}
      <div
        className='hidden breaktwo:block absolute inset-0 z-0 opacity-20'
        style={{
          backgroundImage: `url(${imageUrl('not_feeling_well_v2.svg')})`,
          backgroundRepeat: bgRepeat,
          backgroundPosition: bgPosition,
          backgroundSize: bgSize,
        }}
      />
      <div className='flex-1 flex flex-col items-start justify-between gap-6 md:gap-7 lg:gap-14 w-full relative z-10 h-full'>
        <div className="w-full md:max-w-[400px] lg:max-w-[480px]">
          <RoundInfo containerClasses="mb-4 !px-6 !py-2.5">SCHEDULE NOW</RoundInfo>
          <Typography variant="h1" className="mt-3 md:mt-4 font-bold leading-tight w-full" style={{ fontSize: isLessThan1280 ? (isLessThan640 ? 28 : 32) : 36 }}>
            {'Not Feeling Good About Your App or Website?'}
          </Typography>
        </div>
        <RoundedArrowButton
          text={'Check My Software'}
          typographyStyles={{ fontWeight: 400, fontSize: 16 }}
          containerClasses="text-transform:none text-[#000000] bg-[#FFFFFF] hover:bg-gray-100 w-auto flex-shrink-0 scale-95 origin-left"
          onClick={() => navigate('/contact-us')}
        />
      </div>
      <div className='flex-1 w-full flex breaktwo:hidden items-end justify-end md:-mr-5 lg:-mr-7 relative z-10'>
        <img 
          src={imageUrl('not_feeling_well_v2.svg')} 
          alt="not feeling well" 
          className="w-full md:max-w-none md:w-[85%] lg:w-[90%] h-auto object-contain"
        />
      </div>
    </div>
  )
}

export default NotFeelingWell
